import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../redux/types'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import ScreenLoading from '../../../../shared/components/ScreenLoading'

function UserNotifications() {
  const { error, msg, loading } = useSelector((state: IRootState) => state.user)
  const { error: errorRole, msg: msgRole } = useSelector((state: IRootState) => state.role)
  const { error: errorProvince, msg: msgProvince } = useSelector((state: IRootState) => state.country)
  const { error: errorLanguage, msg: msgLanguage } = useSelector((state: IRootState) => state.language)

  return (
    <>
      <CustomSnackBar
        errors={[error, errorRole, errorProvince, errorLanguage]}
        msgs={[msg, msgRole, msgProvince, msgLanguage]}
      />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default UserNotifications
